import React, { Component } from "react";
import { connect } from "react-redux";
import { Formik } from "formik";
import PropTypes from "prop-types";
import kidSchema from "../Kid-schema";
import kidInitialValue from "./KidInitialValue";
import { Button, Grid, Card, CardContent } from "@material-ui/core/";
import { withStyles } from "@material-ui/core/styles";

import { FormStyles } from "../../../styles";
import { Stepper, Snackbar } from "../../../components";
import { reformatDays } from "../../../utils/helpers";

import KidInformations from "./kid-informations";
import ParentsInformations from "./parents-informations";
import TiersInformations from "./tiers-informations";
import HoraireInformations from "./horaire-informations";
import PhotoComponent from "./photo-component";

import { CardHeader, CardActions } from "../../../components";

import { createKid } from "./Add-kid.ducks";

class AddKid extends Component {
  static propTypes = {
    createKid: PropTypes.func,
    kids: PropTypes.object,
    classes: PropTypes.object
  };

  state = {
    wizzard: 0,
    displayCamera: false,
    activeStep: 0,
    steps: [
      { status: false, text: "kid" },
      { status: false, text: "Parent" },
      { status: false, text: "Tiers" },
      { status: false, text: "Horaire" }
    ],
    snackBarStatus: false
  };

  handleDisplayCamera = () => {
    this.setState({ displayCamera: !this.state.displayCamera });
  };

  handleRightButtonClick = values => {
    if (this.state.wizzard < 3) {
      this.handleNextClick();
    } else {
      this.handleSubmit(values);
    }
  };

  handleSubmit = async values => {
    const data = Object.assign({}, values);
    delete data.days;
    data.horaireDebutDto = reformatDays(values.days);
    await this.props.createKid(data, "token").then(res => {
      this.setState({ snackBarStatus: true });
      setTimeout(() => {
        this.setState({ snackBarStatus: false });
      }, 6000);
    });
  };

  handleNextClick = () => {
    let { steps, wizzard, activeStep } = this.state;
    steps[wizzard].status = true;
    activeStep = wizzard + 1;
    this.setState({ wizzard: wizzard + 1, steps, activeStep });
  };

  handleBackClick = () => {
    let { steps, wizzard, activeStep } = this.state;
    steps[wizzard].status = false;
    steps[wizzard - 1].status = false;
    activeStep = wizzard - 1;
    this.setState({ wizzard: wizzard - 1, steps, activeStep });
  };

  handleAddTier = (setFieldValue, tierceAutorisesDto) => {
    let newTiers = tierceAutorisesDto;
    newTiers.push({
      nom: "",
      prenom: "",
      numeroTel: "",
      lienDeParente: ""
    });
    setFieldValue("tierceAutorisesDto", newTiers);
  };

  handleDeleteTier = (setFieldValue, tierceAutorisesDto, index) => {
    let newTiers = tierceAutorisesDto;
    newTiers.splice(index, 1);
    setFieldValue("tierceAutorisesDto", newTiers);
  };

  render() {
    const {
      formInput,
      formBtn,
      formError,
      formBtnHidden,
      root
    } = this.props.classes;

    const Actions = (values, touched, errors) => (
      <Grid justify="space-between" container spacing={24}>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            className={this.state.wizzard === 0 ? formBtnHidden : null}
            onClick={this.handleBackClick}
          >
            précédant
          </Button>
        </Grid>
        <Grid item>
          <Button
            disabled={
              this.state.wizzard === 3 &&
              (Object.keys(errors).length > 0 ||
                Object.keys(touched).length === 0)
            }
            variant="contained"
            color="primary"
            type={this.state.wizzard === 3 ? "submit" : ""}
            onClick={() =>
              this.handleRightButtonClick(
                this.state.wizzard === 3 ? values : null
              )
            }
          >
            {this.state.wizzard === 3 ? "Créer" : "Suivant"}
          </Button>
        </Grid>
      </Grid>
    );

    return (
      <Card>
        <Formik
          initialValues={kidInitialValue}
          validationSchema={kidSchema}
          onSubmit={(values, actions) => console.log(values)}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            initialValues,
            setFieldValue,
            errors,
            touched
          }) => (
            <form onSubmit={handleSubmit}>
              <CardHeader title="Add Kid" />

              <CardContent className={root}>
                <Stepper
                  steps={this.state.steps}
                  activeStep={this.state.activeStep}
                />
                {(() => {
                  switch (this.state.wizzard) {
                    case 0:
                      return (
                        <Grid justify="space-between" container spacing={24}>
                          <Grid item md={9} sm={12}>
                            <KidInformations
                              setFieldValue={setFieldValue}
                              values={values}
                              touched={touched}
                              errors={errors}
                              handleBlur={handleBlur}
                              handleChange={handleChange}
                              style={{ formBtn, formInput, formError }}
                            />
                          </Grid>
                          <Grid item md={3} sm={12}>
                            <PhotoComponent
                              setFieldValue={setFieldValue}
                              values={values}
                              displayCamera={this.state.displayCamera}
                              handleDisplayCamera={this.handleDisplayCamera}
                            />
                          </Grid>
                        </Grid>
                      );
                    case 1:
                      return (
                        <ParentsInformations
                          setFieldValue={setFieldValue}
                          values={values}
                          touched={touched}
                          errors={errors}
                          style={{ formBtn, formInput, formError }}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                        />
                      );
                    case 2:
                      return (
                        <TiersInformations
                          setFieldValue={setFieldValue}
                          values={values}
                          touched={touched}
                          errors={errors}
                          style={{ formBtn, formInput, formError }}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          handleAddTier={() =>
                            this.handleAddTier(
                              setFieldValue,
                              values.tierceAutorisesDto
                            )
                          }
                          handleDeleteTier={index => {
                            this.handleDeleteTier(
                              setFieldValue,
                              values.tierceAutorisesDto,
                              index
                            );
                          }}
                        />
                      );
                    case 3:
                      return (
                        <HoraireInformations
                          setFieldValue={setFieldValue}
                          values={values}
                          touched={touched}
                          errors={errors}
                          style={{ formBtn, formInput, formError }}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                        />
                      );
                    default:
                      return 0;
                  }
                })()}
              </CardContent>
              <CardActions>{Actions(values, touched, errors)}</CardActions>
              <Snackbar
                snackBarStatus={this.state.snackBarStatus}
                snackBarMessage="L'enfant a été créé avec succès"
              />
            </form>
          )}
        </Formik>
      </Card>
    );
  }
}

const mapStateToProps = ({ kids }) => ({ kids });

const mapDispatchToProps = { createKid };

const withStore = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default withStyles(FormStyles)(withStore(AddKid));
